import {PageTemplate} from "../../shared/layout/PageTemplate";
import {useTranslation} from "react-i18next";
import {Earnings} from "./components/Earnings";

export function ExternalEarnings() {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.earnings')}`} title={`${t('side_bar.earnings')}`}
                         content={<Earnings/>}/>
}